import Tab from "../../Tab";
import React, { useEffect, useState } from "react";
import "../../../css/MoreInfo.css";
import MoreInfoJob from "./MoreInfoJob";
import MoreInfoDriver from "./MoreInfoDriver";
import MoreInfoVehicle from "./MoreInfoVehicle";
import { getJobInfo } from "../../../api/finance/addChargesApi";
import LoadingSpinner from "../../LoadingSpinner";
import { X } from "react-feather";
import MoreInfoOperation from "./MoreInfoOperation";
import { getAdjustedHeight } from "../../../helper";
import MoreInfoStatus from "./MoreInfoStatus";

const MoreInfo = ({
  job,
  vehNo,
  model,
  manufacturer,
  closeJobInfo,
  style,
  isSideNavOpen,
}) => {
  const [tab, setTab] = useState(1);
  const [jobInformation, setJobInformation] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const jobInfo = await getJobInfo(job);
      setJobInformation(jobInfo[0]);
      setIsLoading(false);
    })();
  }, [job]);
  return (
    <div
      className="vehicle-job-content"
      style={
        isSideNavOpen
          ? { ...style, height: getAdjustedHeight(50, 80.5) }
          : style
      }
    >
      <div
        className="ui segment vehicle-job-content-info"
        style={{
          height: isSideNavOpen ? getAdjustedHeight(50, 80.5) : "80.5vh",
          borderRadius: "10px",
          overflowY: "scroll",
          background: "rgba(255, 255, 255, 0.8)",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(255, 255, 255, 0.25)",
          padding: "10px",
        }}
      >
        <X onClick={closeJobInfo} className="vehicle-job-content-info-close" />
        <>
          {isLoading ? (
            <LoadingSpinner />
          ) : (
            <>
              <h2 className="vehicle-job-content-header-primary">{vehNo}</h2>
              <h4 className="vehicle-job-content-header-secondary">
                {jobInformation
                  ? jobInformation.vhtType
                    ? jobInformation.vhtType
                    : "N/A"
                  : "N/A"}
              </h4>
              <h4 className="vehicle-job-content-header-secondary">
                {manufacturer} {model}
              </h4>
              <div className="ui tabular menu top attached">
                <Tab
                  onClick={() => {
                    setTab(1);
                  }}
                  active={tab === 1}
                  label="Job"
                />
                <Tab
                  onClick={() => {
                    setTab(2);
                  }}
                  active={tab === 2}
                  label="Status"
                />
                <Tab
                  onClick={() => {
                    setTab(3);
                  }}
                  active={tab === 3}
                  label="Driver"
                />
                <Tab
                  onClick={() => {
                    setTab(4);
                  }}
                  active={tab === 4}
                  label="Vehicle"
                />
                <Tab
                  onClick={() => {
                    setTab(5);
                  }}
                  active={tab === 5}
                  label="Action"
                />
              </div>
              <div
                className="ui bottom attached active tab segment vehicle-job-content-tab"
                style={{ display: tab === 1 ? "block" : "none" }}
              >
                <MoreInfoJob jobInfo={jobInformation} />
              </div>
              <div
                className="ui bottom attached active tab segment"
                style={{ display: tab === 2 ? "block" : "none" }}
              >
                <MoreInfoStatus
                  requestId={jobInformation?.jobRequest}
                  jobId={jobInformation?.jobId}
                />
              </div>
              <div
                className="ui bottom attached active tab segment"
                style={{ display: tab === 3 ? "block" : "none" }}
              >
                <MoreInfoDriver driverId={jobInformation?.jobDriver} />
              </div>
              <div
                className="ui bottom attached active tab segment"
                style={{ display: tab === 4 ? "block" : "none" }}
              >
                <MoreInfoVehicle vehicleId={jobInformation?.jobVehicle} />
              </div>
              <div
                className="ui bottom attached active tab segment"
                style={{ display: tab === 5 ? "block" : "none" }}
              >
                <MoreInfoOperation jobInfo={jobInformation} />
              </div>
            </>
          )}
        </>
      </div>
    </div>
  );
};

export default MoreInfo;
